var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full"},[_c('GLArtCanvas',{staticClass:"h-full w-full rounded-lg",attrs:{"rounded":'8px 8px 8px 8px'}},[_c('Bloomer',{attrs:{"settings":{
      exposure: 1.0,
      bloomStrength: 1.0,
      bloomThreshold: 20.72 / 100.0,
      bloomRadius: 100.99 / 100.0 * 1
    }}}),_c('FastFlame',{attrs:{"sx":1.5,"sy":1.0,"sz":1.0,"pz":0,"lowres":false}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }